module.exports = __webpack_public_path__ + "static/media/zendrop-logo.eb65a471.svg";